export enum ScreeningReportQueue {
    NEEDS_REVIEW = 'NEEDS_REVIEW',
    REVIEWED = 'REVIEWED'
}
